/*
 * Ela: auto-slide product card images on hover.
 *
 * Horizon already swaps to the 2nd image on hover (product-card previewImage)
 * and back on leave (resetImage). This script adds: while the cursor stays on
 * the card image, keep advancing to the next image every 0.9s — but only for
 * products with MORE than 2 images (2-image cards keep the simple swap).
 * On leave it returns the gallery to the first image.
 */
(function () {
  var INTERVAL_MS = 900;

  function getSlideshow(gallery) {
    return gallery.querySelector('slideshow-component');
  }

  function visibleSlideCount(slideshow) {
    return slideshow.querySelectorAll('slideshow-slide:not([hidden])').length;
  }

  function startAuto(gallery) {
    stopAuto(gallery, false);

    var slideshow = getSlideshow(gallery);
    if (!slideshow || typeof slideshow.next !== 'function') return;
    if (visibleSlideCount(slideshow) <= 2) return;

    gallery.__elaSlideTicked = false;
    gallery.__elaSlideTimer = setInterval(function () {
      // Guard against the tab being hidden or the element being detached
      // (e.g. grid re-rendered by filters) while the timer is running.
      if (document.hidden || !document.body.contains(slideshow)) {
        stopAuto(gallery, false);
        return;
      }
      gallery.__elaSlideTicked = true;
      slideshow.next(undefined, { animate: false });
    }, INTERVAL_MS);
  }

  function stopAuto(gallery, reset) {
    if (gallery.__elaSlideTimer) {
      clearInterval(gallery.__elaSlideTimer);
      gallery.__elaSlideTimer = null;
    }
    if (reset && gallery.__elaSlideTicked) {
      gallery.__elaSlideTicked = false;
      var slideshow = getSlideshow(gallery);
      if (!slideshow || typeof slideshow.select !== 'function') return;
      // Defer so the theme's own resetImage (previous()) runs first, then
      // settle on the first image regardless of where the cycle ended.
      setTimeout(function () {
        slideshow.select(0, undefined, { animate: false });
      }, 50);
    }
  }

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var gallery = e.target.closest('.main-collection-grid .card-gallery');
    if (!gallery) return;
    if (gallery.contains(e.relatedTarget)) return; // moving within the card
    startAuto(gallery);
  });

  document.addEventListener('pointerout', function (e) {
    var gallery = e.target.closest('.main-collection-grid .card-gallery');
    if (!gallery) return;
    if (gallery.contains(e.relatedTarget)) return; // still within the card
    stopAuto(gallery, true);
  });
})();
